import { Component } from '@angular/core';

@Component({
  selector: 'app-orari-scientific-session24',
  templateUrl: './orari-scientific-session24.component.html',
  styleUrl: '../../../../../../../styles-tabelle-orari.css'
})
export class OrariScientificSession24Component {

}
